//import jwt_decode from "jwt-decode";

import {
    showProcessSuccessMessage,
    showProcessErrorMessage,
    showProcessPromptMessage
} from "../../state/alertHelpers.js";

import {
    getProjects,
    addProject,
    updateProject,
    deleteProject,
    getSingleProject,
    getProjectsBySearch,
    approveProject,
    updateProjectCode, getSingleProjectByCode,
} from "@/services/modules/project/projectService";
import store from "@/state/store";

export const state = {
    projectList: [],
    projectListBySearch: [],
    projectListMetaData: {},
    projectListHeaders: [],
    projectListLoading: false,
    noProjectMessage: "",
};

export const mutations = {
    setProjectList(state, data) {
        state.projectList = data;
    },
    setProjectListBySearch(state, data) {
        state.projectListBySearch = data;
    },
    setProjectListMetaData(state, data) {
        state.projectListMetaData = data;
    },
    setProjectListHeaders(state, data) {
        state.projectListHeaders = data;
    },
    setProjectListLoading(state, data) {
        state.projectListLoading = data;
    },
    setNoProjectMessage(state, data) {
        state.noProjectMessage = data;
    },
}

export const getters = {};

export const actions = {
    async fetchProjectList(context, {params, body}) {
        context.commit("setProjectListLoading", true);
        let result = await getProjects(params, body);
        if (result.data.data) {
            result.data.data.forEach(item => {
                if (item.startDate && item.endDate) {
                    item.startDate = item.startDate.split('T')[0];
                    item.endDate = item.endDate.split('T')[0];
                }
            });
        }
        context.commit("setProjectListMetaData", {
            totalCount: result.data.totalCount,
            totalPages: result.data.totalPages
        });

        let headers = [
            {
                key: 'createDate',
                label: 'Oluşturulma Tarihi',
                sortable: false,
                visible: true,
                class: "text-center align-middle",

            },
            {
                key: 'code',
                label: 'Proje Kodu',
                sortable: false,
                visible: true,
                class: "text-center align-middle text-nowrap",

            },
            {
                key: 'name',
                label: 'İsim',
                sortable: false,
                visible: true,
                class: "text-center align-middle",
            },
            {
                key: 'startDate',
                label: 'Başlangıç Tarihi',
                sortable: false,
                visible: true,
                class: "text-center align-middle",

            },
            {
                key: 'endDate',
                label: 'Bitiş Tarihi',
                sortable: false,
                visible: true,
                class: "text-left align-middle",

            },
            {
                key: 'companyName',
                label: 'Şirket',
                sortable: false,
                visible: false,
                class: "text-center align-middle",

            },
            {
                key: 'projectType',
                label: 'Proje Tipi',
                sortable: false,
                visible: true,
                class: "text-center align-middle",

            },
            {
                key: 'companyCity',
                label: 'Şehir',
                sortable: false,
                visible: true,
                class: "text-center align-middle",

            },
            {
                key: 'authorizedName',
                label: 'Yetkili',
                sortable: false,
                visible: true,
                class: "text-center align-middle",

            },
            {
                key: 'createUser',
                label: 'Kayıt Yapan',
                sortable: false,
                visible: true,
                class: "text-center align-middle",
            },
            {
                key: 'status',
                label: 'Durum',
                sortable: true,
                visible: true,
                class: "text-center align-middle",
            },
            {
                key: 'process',
                label: 'İşlem',
                sortable: false,
                class: "text-center align-middle text-nowrap",
                visible: store.state.auth.user.RoleGroupId === '1' || store.state.auth.user.RoleGroupId === 1 || store.state.auth.user.RoleGroupId === "2" || store.state.auth.user.RoleGroupId === 2,
            }

        ];

        context.commit("setProjectListHeaders", headers);
        context.commit("setProjectListLoading", false);

        if (result.data.success) {
            context.commit("setProjectList", result.data.data);
            return result.data.data;
        } else {
            context.commit("setProjectList", []);
            context.commit("setNoProjectMessage", result.data.message);
            return [];
        }
    },

    async fetchProjectListBySearch(context, {params, body}) {
        context;
        context.commit("setProjectListLoading", true);
        let result = await getProjectsBySearch(params, body);

        context.commit("setProjectListLoading", false);

        if (result.data.success) {
            context.commit("setProjectListBySearch", result)
            return result.data.data;
        } else {
            context.commit("setProjectListBySearch", []);
            context.commit("setNoProjectMessage", result.data.message);
            return [];
        }
    },

    async fetchSingleProject(context, {params, body, urlSegments}) {
        context;
        let result = await getSingleProject(params, body, urlSegments);

        if (result.data.success) {
            return result.data.data;
        } else {
            return [];
        }
    },

    async fetchSingleProjectByCode(context, {params, body, urlSegments}) {
        context;
        let result = await getSingleProjectByCode(params, body, urlSegments);

        if (result.data.success) {
            return result.data.data;
        } else {
            return [];
        }
    },

    async projectAdd(context, {params, body}) {
        context;
        let result = await addProject(params, body);
        if (result.data.success) {
            showProcessSuccessMessage({
                title: 'İşlem Başarılı',
                text: result.data.message
            }).then(
                context.dispatch('fetchProjectList', {
                    params: {
                        userId: store.state.auth.user.UserId
                    },
                    body: {},
                })
            );
        } else
            showProcessErrorMessage({
                title: 'İşlem Başarısız',
                text: result.data.message
            })
        return result;
    },

    async projectUpdate(context, {params, body}) {

        let result = await updateProject(params, body);
        if (result.data.success) {
            showProcessSuccessMessage({
                title: 'İşlem Başarılı',
                text: result.data.message
            })
        } else
            showProcessErrorMessage({
                title: 'İşlem Başarısız',
                text: result.data.message
            })
        return result;
    },

    async projectUpdateCode(context, {params, body}) {

        let result = await updateProjectCode(params, body);
        if (result.data.success) {
            showProcessSuccessMessage({
                title: 'İşlem Başarılı',
                text: result.data.message
            })
        } else
            showProcessErrorMessage({
                title: 'İşlem Başarısız',
                text: result.data.message
            })
        return result;
    },

    async projectDelete(context, {params, body, urlSegments}) {

        await showProcessPromptMessage({
            title: 'Proje Silinecek',
            text: "Yapılan işlem geri alınamayacaktır. İşleme devam etmek istiyor musunuz ?",
        }).then(async function (confirm) {
                if (confirm.isConfirmed) {

                    let result = await deleteProject(params, body, urlSegments);
                    if (result.data.success)
                        showProcessSuccessMessage({
                            title: 'İşlem Başarılı',
                            text: result.data.message,
                        }).then(
                            context.dispatch('fetchProjectList', {
                                params: {
                                    userId: store.state.auth.user.UserId
                                },
                                body: {},
                            })
                        );
                    else
                        showProcessErrorMessage({
                            title: 'İşlem Başarısız',
                            text: result.data.message,
                        });

                    return result;
                }
            }
        )
    },

    async projectApprove(context, {params, body, urlSegments}) {

        await showProcessPromptMessage({
            title: 'Proje Onaylanacak',
            text: "Yapılan işlem geri alınamayacaktır. İşleme devam etmek istiyor musunuz ?",
        }).then(async function (confirm) {
                if (confirm.isConfirmed) {

                    let result = await approveProject(params, body, urlSegments);
                    if (result.data.success)
                        showProcessSuccessMessage({
                            title: 'İşlem Başarılı',
                            text: result.data.message,
                        }).then(
                            context.dispatch('fetchProjectList', {
                                params: {
                                    userId: store.state.auth.user.UserId
                                },
                                body: {},
                            })
                        );
                    else
                        showProcessErrorMessage({
                            title: 'İşlem Başarısız',
                            text: result.data.message,
                        });

                    return result;
                }
            }
        )
    },

};
